<template>
  <div>
    <Loader v-if="loading"/>
    <div v-else class="m-8">
      <div class="mb-4">
        <h2 class="text-3xl">{{ $lang.app.PROFILE }}</h2>
      </div>
      <div class="shadow shadow-indigo-600 rounded-md p-5 relative bg-white mb-6">
        <h2 class="text-blue-600 font-bold text-xl mb-3.5">
          {{ profileInfo.fullName }}
        </h2>
        <div class="flex">
          <Avatar :id="profileInfo.id" :photo="profileInfo.photo" :editable="false"/>
          <div class="w-full ml-5">
            <div class="flex items-baseline text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.USERNAME }} :</div>
              <p>
                <span class="text-lg text-blue-800">{{ profileInfo.employment.fullName }}</span>
                ({{ $lang.$translate({ru: profileInfo.employment.position.nameRu, kg: profileInfo.employment.position.nameKg}) }})
              </p>
            </div>
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.ROLE }} :</div>
              <p>{{ $lang.app[rolesGetLabelRefByKey(profileInfo.role)] }}</p>
            </div>
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.DEPARTMENT }} :</div>
              <p>{{ $lang.$translate({ru: profileInfo.employment.position.department.nameRu, kg: profileInfo.employment.position.department.nameKg}) }}</p>
            </div>
            <div class="flex text-sm mb-2">
              <div class="text-gray-600 w-1/4">{{ $lang.app.STATE }} :</div>
              <p>{{ $lang.$translate({ru: profileInfo.employment.position.department.states.nameRu, kg: profileInfo.employment.position.department.states.nameKg}) }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="shadow shadow-indigo-600 p-5 rounded-md bg-white mb-6">
        <div class="overflow-x-auto overflow-y-auto">
          <ul class="w-full flex bg-indigo-50 rounded-lg">
            <li v-for="tab in tabs" :key="tab.key" class="w-1/6">
              <button class="w-full text-md font-medium p-3 rounded-lg"
                      :class="[tab.key === activeTab.key ? 'bg-indigo-700 text-white' : 'text-indigo-700']"
                      @click="activeTab = tab">{{ tab.title }}</button>
            </li>
          </ul>
          <div class="w-full py-8">
            <component :is="activeTab.component" :profile="profileInfo"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import userApi from "../../../api/users";
import {
  getValueByKey as userTypesGetValue,
  getLabelRefByValue as userTypesGetLabelRefByValue
} from "../../../helpers/constants/userTypes";
import {getLabelRefByKey as rolesGetLabelRefByKey} from "../../../helpers/constants/roles";
import Avatar from "../../../components/applicant/profile/Avatar";
import Positions from "../../../components/employee/profile/Positions";
import Contacts from "../../../components/employee/profile/Contacts";

export default {
  components: {
    Avatar,
    Positions,
    Contacts,
  },
  data() {
    return {
      loading: false,
      activeTab: {
        key: 'positions',
        title: this.$lang.app.POSITIONS,
        component: 'Positions'
      },
      tabs: [
        {
          key: 'positions',
          title: this.$lang.app.POSITIONS,
          component: 'Positions'
        },
        {
          key: 'contacts',
          title: this.$lang.app.CONTACTS,
          component: 'Contacts'
        },
      ],
      profileInfo: null,
    }
  },
  created() {
    this.fetchProfileInfo()
  },
  methods: {
    userTypesGetValue,
    userTypesGetLabelRefByValue,
    rolesGetLabelRefByKey,
    fetchProfileInfo() {
      this.loading = true
      userApi.profile()
          .then(response => response.data.data)
          .then((res) => {
            this.profileInfo = res;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() => {
        this.loading = false
      });
    },
  },
  beforeMount() {
    this.$emitter.on('refresh-profile', () => {
      this.fetchProfileInfo()
    })
  },
  beforeUnmount() {
    this.$emitter.off('refresh-profile')
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$emitter.emit('closeSidebar')
    })
  },
}
</script>